/** @jsx jsx */
import { jsx } from '@emotion/core';
import { CircularProgress } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import LinkIcon from '@material-ui/icons/Link';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import { Component, Fragment } from 'react';
import { accordionStyles } from './Accordion.style';

interface IProps {
  connected: boolean;
  spinner?: boolean;
  error?: boolean;
  touched?: boolean;
}

class AccordionIcon extends Component<IProps> {
  renderIcon(): JSX.Element {
    const { connected, spinner, error, touched } = this.props;
    if (error && touched) {
      return <ErrorIcon color="error" data-testid="iconError" />;
    }
    if (spinner) {
      return (
        <CircularProgress
          data-testid="iconSpinner"
          color="secondary"
          css={accordionStyles.spinner}
        />
      );
    }
    if (connected) {
      return (
        <LinkIcon
          color="secondary"
          data-testid="iconSuccess"
          className={'connectedIcon'}
        />
      );
    }
    return (
      <LinkOffIcon
        color="disabled"
        data-testid="iconLink"
        className={'connectedIcon'}
      />
    );
  }

  render(): JSX.Element {
    return <Fragment>{this.renderIcon()}</Fragment>;
  }
}

export default AccordionIcon;
